export default __webpack_public_path__ + "static/media/radio75.9aec9ab7.jpeg";